var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],class:[
    'dp-alert',
    ("dp-alert--" + _vm.type),
    {
      'dp-alert--overlayed': _vm.overlayed,
    } ]},[(_vm.closeable)?_c('a',{staticClass:"dp-alert__close",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.closeAlert.apply(null, arguments)}}},[_c('dp-icon',{attrs:{"name":"simple-cross","size":"16"}})],1):_vm._e(),(_vm.message)?_c('p',[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }